let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2C1eK")).then(() => parcelRequire('8a87x'));